import { render, staticRenderFns } from "./SViewerLogo.vue?vue&type=template&id=223f09ba&scoped=true"
import script from "./SViewerLogo.vue?vue&type=script&lang=js"
export * from "./SViewerLogo.vue?vue&type=script&lang=js"
import style0 from "./SViewerLogo.vue?vue&type=style&index=0&id=223f09ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f09ba",
  null
  
)

export default component.exports